module.exports = __webpack_public_path__ + "img/empty-living-room-2251247.4074982d.jpg";